import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../theme/aikya';
import { Header }  from './Header';
import { PageWrapper } from './PageWrapper.js';
import { FontsSection } from './FontsSection';
import { FooterSection } from './FooterSection';

export class FontsPage extends React.Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <PageWrapper>
                    <Header />
                    <FontsSection />
					<FooterSection />
                </PageWrapper>
            </ThemeProvider>
        );
    }
}